export class Navigation {
    private isOpen = false;
    private container: JQuery;
    private menuBtn: JQuery;
    private search: JQuery;

    constructor() {
        this.container = $('#js-site-nav');
        this.menuBtn   = $('.js-site-nav__menu-btn');
        this.search    = $('#js-site-search');

        this.addListeners();
    }


    /**
     * Adds the event listeners for this component.
     *
     * @private
     * @memberof Navigation
     */
    private addListeners(): void {

        // Menu button clicks.
        this.menuBtn.on('click', () => {
            this.toggleMenu();
        });

        // Escape button
        $(document).on('keyup', event => {
            if(event.key === 'Escape' || event.key === 'Esc') {
                this.closeMenu();
            }
        });

        // Escape button
        $(document).on('keyup', event => {
            if(event.key === 'Escape' || event.key === 'Esc') {
                this.closeMenu();
            }
        });

        // On background click
        this.container.on('click', event => {      
            if(event.target === this.container.get(0)) {
                this.closeMenu();
            }
        });

        // Contact Link
        $('#js-site-nav__contact-link').on('click', event => {
            event.preventDefault();
            this.displayContact((event.currentTarget as HTMLAnchorElement).href);
        });

        // Site Search
        $('.js-site-nav__toggle-search').on('click', () => {
            this.toggleSearch();
        });
    }


    /**
     * Toggles the visibility on the menu.
     *
     * @private
     * @memberof Navigation
     */
    private toggleMenu(): void {
        if(this.isOpen) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }


    /**
     * Toggles the visibility on the menu.
     *
     * @private
     * @memberof Navigation
     */
    private closeMenu(): void {
        this.isOpen = false;
        this.container.removeClass('c-site-nav--is-visible');
    }


    /**
     * Toggles the visibility on the menu.
     *
     * @private
     * @memberof Navigation
     */
    private openMenu(): void {
        this.isOpen = true;
        this.container.addClass('c-site-nav--is-visible');
    }


    /**
     * Displays the contacr block if it exists, else redirects.
     * 
     * @param fallbackURL The URL to redirect to
     */
    private displayContact(fallbackURL: string): void {
        const contactBlock = $('#contact');
        if(contactBlock.length) {

            // Close the menu
            this.closeMenu();

            // Open the contact form
            window.app.modules.contact.open(() => {

                // Scroll into view
                contactBlock.get(0).scrollIntoView({
                    behavior: 'smooth'
                });
            });
        } else {
            window.location.href = fallbackURL;
        }
    }


    /**
     * Toggle the search form.
     *
     * @private
     * @memberof Navigation
     */
    private toggleSearch(): void {
        this.search.toggleClass('c-site-search--is-visible');
    }
}
